<template>
  <router-view />
</template>

<script>
export default {
  name: 'ProductStorageIndex'
}
</script>
